var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgHelpIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 18,
    height: 18,
    viewBox: "0 0 18 18",
    fill: "currentColor",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M9.00033 0.666626C13.6027 0.666626 17.3337 4.39759 17.3337 8.99996C17.3337 13.6023 13.6027 17.3333 9.00033 17.3333C4.39795 17.3333 0.666992 13.6023 0.666992 8.99996C0.666992 4.39759 4.39795 0.666626 9.00033 0.666626ZM9.00033 2.33329C5.31843 2.33329 2.33366 5.31806 2.33366 8.99996C2.33366 12.6819 5.31843 15.6666 9.00033 15.6666C12.6822 15.6666 15.667 12.6819 15.667 8.99996C15.667 5.31806 12.6822 2.33329 9.00033 2.33329ZM9.00033 12.3333C9.46056 12.3333 9.83366 12.7064 9.83366 13.1666C9.83366 13.6269 9.46056 14 9.00033 14C8.54009 14 8.16699 13.6269 8.16699 13.1666C8.16699 12.7064 8.54009 12.3333 9.00033 12.3333ZM9.00033 3.99996C10.8413 3.99996 12.3337 5.49234 12.3337 7.33329C12.3337 8.82897 11.3486 10.0946 9.99182 10.5167L9.83366 10.5616V10.6666C9.83366 11.1269 9.46056 11.5 9.00033 11.5C8.57296 11.5 8.22074 11.1783 8.1726 10.7638L8.16699 10.6666V9.83329C8.16699 9.40593 8.48869 9.0537 8.90314 9.00557L9.12471 8.99539C9.98709 8.93176 10.667 8.21193 10.667 7.33329C10.667 6.41282 9.9208 5.66663 9.00033 5.66663C8.07985 5.66663 7.33366 6.41282 7.33366 7.33329C7.33366 7.79353 6.96056 8.16663 6.50033 8.16663C6.04009 8.16663 5.66699 7.79353 5.66699 7.33329C5.66699 5.49234 7.15938 3.99996 9.00033 3.99996Z",
    fill: "currentColor"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgHelpIcon);
export default __webpack_public_path__ + "static/media/helpIcon.aab2ffa3.svg";
export { ForwardRef as ReactComponent };